/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Коллекция для категории с товарами
   */
  app.WishItems = app.ItemPageableCollection.extend({

    model: app.Model,
    categoryId: null,
    changed: false,

    url: app.entryScriptName + '/api/v3/item/',

    canRemoveItems: true,
    sortTypes: ['-created', '-date', 'price', '-price', 'price-unit', '-price-unit', 'name', 'sid', 'discount'],
    state: {
      firstPage: 1,
      pageSize: 20,
      order: 0
    },

    defaults: {
      pageSize: 20,
      sort: '-created',
      viewtype: 'cards',
      f: 'null',
      mode: 'server'
    },

    initialize: function () {
      app.ItemPageableCollection.prototype.initialize.apply(this, arguments);
      this.setQueryParams();
      // текущая валюта на сайте
      this.currency = app.currentCurrency || {};
      this.currencyId = this.currency.name;
      this.currencySign = this.currency.sign;

      // устанавливаем дефолтные свойства
      this.setDefaultProperties();
    },

    /**
     * @inheritDoc
     */
    setQueryParams: function () {
      var that = this;
      this.queryParams = {
        totalRecords: function () {
          return that.totalPages;
        },
        currentPage: 'page',
        pageSize: 'per-page',
        currency: function () {
          return that.currencyId;
        },
        sort: function () {
          return that.sort;
        },
        f: function () {
          return that.filter;
        },
        is_wish: 1, 
        with_adult: 1,
        is_deleted: 0,
      };

      var modifiersParam = app.helpers.CookieHelper.getCookie('new_modifiers') ? 'small_modifiers' : 'modifier_items';
      this.queryParams.expand = [
        modifiersParam,
        'cart_item',
        'wish_item',
        'delivery_info',
        'attrs',
        'nestedUnit',
        'fast_delivery_balance',
        'files',
        'photo_sizes',
        'badges',
        'retail_fee_markup',
        'is_available_in_settlement',
      ].join(',');
    },
    needFilters: function () {
      if (this.changed) {
        this.changed = false;
        return true;
      }
      return app.ItemPageableCollection.prototype.needFilters.apply(this, arguments);
    }
  });
})();

}.call(window));